/* ==========================================================================
   MADHOURS - PDP swipe gallery, delivery estimate, trust icons, accordion icons.

   SECTION RE-RENDERS ARE THE HARD PART. The product section is block-based, so
   every spacing slider in the theme editor re-renders it, which wipes the swipe
   rail out of the DOM. The marker class that hides the ORIGINAL gallery lives on
   <body>, and Shopify does not replace <body> on a section re-render - so the
   class survived while the rail did not, the original gallery stayed hidden,
   and the media column went blank.

   Everything below is therefore idempotent and re-runnable:
     - a rail that exists but is detached counts as missing
     - the marker class is removed the moment the rail is missing
     - the marker is only re-applied AFTER a rail is actually inserted
     - shopify:section:load / :select re-run setup in the theme editor

   DELIVERY DATES are computed in the SHOPPER's timezone and skip weekends. The
   numbers come from the published policy ("ships in 3-5 business days", free US
   standard, $15 Express). If carrier transit differs, change TRANSIT_* only.
   ========================================================================== */
(function () {
  'use strict';

  var HANDLING_MAX = 5, HANDLING_MIN = 3, TRANSIT_STD = 4, TRANSIT_EXP = 2;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var PANE_W = 900;
  var MARK = 'mh-has-swipe';

  var ICONS = {
    check:   ['m7 12.5 3 3 7-7', 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z'],
    truck:   ['M2 4.5h11.5v11H2z', 'M13.5 8.5h4L21 12v3.5h-7.5z', 'M6.5 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M17.5 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'],
    box:     ['M21 8v8l-9 5-9-5V8l9-5 9 5Z', 'm3 8 9 5 9-5', 'M12 13v8'],
    clock:   ['M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z', 'M12 6.75V12l3.5 2'],
    lock:    ['M8 10V7a4 4 0 1 1 8 0v3', 'M5.5 10h13v10.5h-13z'],
    chevron: ['m6 9 6 6 6-6']
  };

  function icon(name, size) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    ICONS[name].forEach(function (d) {
      var p = document.createElementNS(SVG_NS, 'path');
      p.setAttribute('d', d);
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '1.6');
      p.setAttribute('stroke-linecap', 'round');
      p.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(p);
    });
    return svg;
  }

  /* --- Trust callouts --------------------------------------------------- */
  function decorateTrust() {
    Array.prototype.forEach.call(document.querySelectorAll('.mh-trust li'), function (li) {
      if (li.getAttribute('data-mh-icon')) return;
      li.setAttribute('data-mh-icon', '1');
      var t = (li.textContent || '').toLowerCase();
      var name = t.indexOf('ship') > -1 && t.indexOf('free') > -1 ? 'truck'
               : t.indexOf('business day') > -1 || t.indexOf('ships in') > -1 ? 'clock'
               : t.indexOf('secure') > -1 || t.indexOf('checkout') > -1 ? 'lock'
               : 'check';
      var wrap = document.createElement('span');
      wrap.className = 'mh-trust__icon';
      wrap.appendChild(icon(name, 17));
      li.insertBefore(wrap, li.firstChild);
    });
  }

  /* --- Accordion -------------------------------------------------------- */
  function decorateAccordion() {
    Array.prototype.forEach.call(document.querySelectorAll('.mh-acc__head'), function (head) {
      if (head.getAttribute('data-mh-icon')) return;
      head.setAttribute('data-mh-icon', '1');
      var label = (head.textContent || '').toLowerCase();
      var name = label.indexOf('ship') > -1 ? 'truck'
               : label.indexOf('return') > -1 ? 'box'
               : 'check';
      var lead = document.createElement('span');
      lead.className = 'mh-acc__icon';
      lead.appendChild(icon(name, 19));
      head.insertBefore(lead, head.firstChild);
      var sign = head.querySelector('.mh-acc__sign');
      if (sign) { sign.textContent = ''; sign.appendChild(icon('chevron', 17)); }
    });
  }

  /* --- Delivery estimate ------------------------------------------------ */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime()), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }

  function fmt(d) {
    try { return d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' }); }
    catch (e) { return d.toDateString(); }
  }

  function deliveryEstimate() {
    if (document.querySelector('.mh-eta')) return null;
    var now = new Date();
    var wrap = document.createElement('div');
    wrap.className = 'mh-eta';
    [['Estimated delivery', addBusinessDays(now, HANDLING_MAX + TRANSIT_STD)],
     ['Get it rushed', addBusinessDays(now, HANDLING_MIN + TRANSIT_EXP)]
    ].forEach(function (row) {
      var p = document.createElement('p');
      p.className = 'mh-eta__line';
      p.appendChild(document.createTextNode('– ' + row[0] + ': '));
      var b = document.createElement('strong');
      b.textContent = fmt(row[1]);
      p.appendChild(b);
      wrap.appendChild(p);
    });
    return wrap;
  }

  function buildBuyBlock() {
    var cart = document.querySelector('.product-content-box .add-to-cart');
    var chip = document.querySelector('.mh-fit__chip');
    if (!cart) {
      var eta = deliveryEstimate();
      if (chip && eta) chip.parentNode.insertBefore(eta, chip.nextSibling);
      return;
    }
    if (chip && chip.parentNode !== cart) cart.appendChild(chip);
    var block = deliveryEstimate();
    if (block) cart.appendChild(block);
  }

  /* --- Swipe media gallery ---------------------------------------------- */
  function sizedUrl(raw, width) {
    if (!raw) return null;
    var url = raw.indexOf('//') === 0 ? window.location.protocol + raw : raw;
    if (url.indexOf('/cdn/shop/') === -1 && url.indexOf('cdn.shopify.com') === -1) return url;
    url = url.replace(/([?&])(width|height)=\d+/g, '$1').replace(/[?&]+$/, '').replace(/([?&])&+/g, '$1');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function liveRail() {
    var r = document.querySelector('.mh-swipe');
    return r && r.isConnected ? r : null;   // a detached rail is a missing rail
  }

  function buildSwipe() {
    var box = document.querySelector('.product-image-box');
    if (!box) return false;

    var sources = document.querySelectorAll('.product-img-grid-item img');
    if (sources.length < 2) return false;   // a single photo needs no gallery

    var rail = document.createElement('div');
    rail.className = 'mh-swipe';
    rail.setAttribute('role', 'region');
    rail.setAttribute('aria-label', 'Product images');

    Array.prototype.forEach.call(sources, function (src, i) {
      var pane = document.createElement('div');
      pane.className = 'mh-swipe__pane';
      var img = document.createElement('img');
      img.src = sizedUrl(src.getAttribute('src'), PANE_W);
      img.alt = src.getAttribute('alt') || '';
      img.loading = 'eager';
      img.decoding = 'async';
      img.setAttribute('fetchpriority', i === 0 ? 'high' : 'low');
      pane.appendChild(img);
      rail.appendChild(pane);
    });

    var dots = document.createElement('div');
    dots.className = 'mh-swipe__dots';
    for (var i = 0; i < sources.length; i++) {
      var dot = document.createElement('span');
      dot.className = 'mh-swipe__dot' + (i === 0 ? ' mh-swipe__dot--on' : '');
      dots.appendChild(dot);
    }

    box.insertBefore(rail, box.firstChild);
    box.insertBefore(dots, rail.nextSibling);

    // Only NOW is it safe to hide the original gallery.
    document.body.classList.add(MARK);

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var panes = rail.children;
        var mid = rail.scrollLeft + rail.clientWidth / 2;
        var best = 0, bestGap = Infinity;
        for (var j = 0; j < panes.length; j++) {
          var c = panes[j].offsetLeft + panes[j].offsetWidth / 2;
          var gap = Math.abs(c - mid);
          if (gap < bestGap) { bestGap = gap; best = j; }
        }
        for (var k = 0; k < dots.children.length; k++) {
          dots.children[k].classList.toggle('mh-swipe__dot--on', k === best);
        }
      });
    }, { passive: true });

    return true;
  }

  /* Reconciles DOM and marker class. Safe to call any number of times. */
  function ensureSwipe() {
    if (liveRail()) return;                       // already good
    document.body.classList.remove(MARK);         // never hide with no rail present
    var orphanDots = document.querySelector('.mh-swipe__dots');
    if (orphanDots && orphanDots.parentNode) orphanDots.parentNode.removeChild(orphanDots);
    buildSwipe();
  }

  function run() {
    decorateAccordion();
    decorateTrust();
    ensureSwipe();
    buildBuyBlock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Theme editor: any block edit or spacing change re-renders the section.
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', ensureSwipe);
  document.addEventListener('shopify:block:select', ensureSwipe);
})();
